// src/redux/reducers/siteReducer.js
import { SET_SUPPORT_PARAM } from '../actions/supportedparamActions';

const initialState = {
    supportparamList: [],
};

const supportedparamReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUPPORT_PARAM:
      return {
        ...state,
        supportparamList: action.payload,
      };
    default:
      return state;
  }
};

export default supportedparamReducer;
